
import { Component, Input } from '@angular/core';
import { PRM } from '@reflact/prmacweb';
import { LayoutDirective } from '../../../shared/services/layout.directive';
import { LayoutService } from '../../../shared/services/layout.service';
import Participant = PRM.Participant;

@Component({
  selector: 'app-user-image-and-name-display',
  templateUrl: './user-image-and-name-display.component.html',
  styleUrls: ['./user-image-and-name-display.component.css'],
  imports: [
    LayoutDirective
],
  standalone: true
})
export class UserImageAndNameDisplayComponent {
  @Input() public participant: PRM.IpadParticipant;
  @Input() public showName = true;

  constructor(public layoutService: LayoutService) { }
}